<template>
<div class="form">
<a-card :title="c_title">
    <v-gobackbutton v-show="isGuide != 'process'" slot="extra" >返回</v-gobackbutton>
        <a-form-model :model="record" ref="ruleForm" :rules="rules" :layout="formItemLayout"  :label-col="labelCol" :wrapper-col="wrapperCol">
            <a-form-model-item ref="templateid" label="模板ID" prop="templateid">
                <a-input
                    v-model="record.templateid"
                     @blur="
                        () => {
                            $refs.templateid.onFieldBlur();
                        }
                        "
                />
            </a-form-model-item>
            <a-form-model-item ref="businesstype" label="业务类型" prop="businesstype">
                <a-input
                    v-model="record.businesstype"
                     @blur="
                        () => {
                            $refs.businesstype.onFieldBlur();
                        }
                        "
                />
            </a-form-model-item>
            <a-form-model-item ref="paramskey" label="模版参数" prop="paramskey">
                <a-input
                    v-model="record.paramskey"
                     @blur="
                        () => {
                            $refs.paramskey.onFieldBlur();
                        }
                        "
                />
            </a-form-model-item>
            <a-form-model-item v-show="is_vue_task"  style="text-align: center">
                <a-button type="primary" @click="handleOk">
                    保存
                </a-button>
                <a-button style="margin-left: 10px;" @click="handleCancel">
                    取消
                </a-button>
            </a-form-model-item>
        </a-form-model>

 </a-card>
</div>
  
</template>
<script>
import { mapState } from "vuex";
const m_title = {
    'add':'新增微信模版',
    'edit':'编辑微信模版',
};
export default {
    data() {
        return {
            c_title:'',
            is_vue_task : true,
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
            type:'',
            rules: {
                templateid: [
                    { required: true, message: '请输入 模板ID', trigger: 'blur' },
                    { min: 1, max: 100, message: '请输入1~100个字符', trigger: 'blur' },
                ],
                businesstype: [
                    { required: true, message: ' 请输入 业务类型 ', trigger: 'blur' },
                    { min: 1, max: 50, message: '请输入1~50个字符', trigger: 'blur' },
                ],
                paramskey: [
                    { required: false, message: '请输入 模板参数', trigger: 'blur' },
                    { min: 1, max: 200, message: '请输入1~200个字符', trigger: 'blur' },
                ],
            },
            confirmLoading: false,
            formItemLayout:'horizontal'
        };
    },
    props:{
        isGuide:String
    },
    computed: {
        ...mapState("wxtemplatemanager", {
            record: function(state) {
                console.log("state===>"+state);
                return this.action == "addsubtemplate" ? {} : state.record;
            }
        })
    },

    methods: {
        handleOk() {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    this.confirmLoading = true;
                    const { params } = this.$route;
                   
                    let c_params = {
                        ...this.record
                    }
                    c_params.tableType = "2";
                    if(params.action == 'editsubTemplate' || params.action == 'detailsubTemplate'){
                        //编辑
                        this.record.id = this.record.id;
                       
                        this.$store.dispatch({
                            type: "wxtemplatemanager/editTemplate",
                            params: c_params
                        }).then((response) => {
                            if(response.data.success == '1'){
                                console.log(response)
                                this.handleCancel();
                                this.confirmLoading = false;
                            }
                        });
                    }
                    else if(params.action == 'addsubtemplate'){
                        //新增
                        this.$store.dispatch({
                            type: "wxtemplatemanager/addTemplate",
                            params: c_params
                        }).then((response) => {
                            if(response.data.success == '1'){
                                console.log(response)
                                this.handleCancel();
                            }
                        });
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
            
        },

        handleCancel() {
            this.resetForm();
            this.$router.back(-1);
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
        },
    },

    mounted(){
        const { query, params } = this.$route;
        this.c_title = m_title[params.action];
        this.type = params.action == "addhsubtemplate";
        if (params.action != "addsubtemplate") {
            this.$store.dispatch({
                type: "wxtemplatemanager/detailTemplate",
                params: query,
                showMsg: false
            })
        }
        else{
            this.$store.dispatch({
                type: "wxtemplatemanager/getEmptySearch",
                params: query,
                showMsg: false
            })  
        }
        this.is_vue_task = params.action != 'orgdetail'
        
    }
};
</script>

<style scoped>
.ant-form-inline .ant-form-item{
    margin-right:40px;
}
</style>
